import MobileLink from './MobileLink'

export default MobileLink
